import axios from "axios";
import Token from "../config/token.service";
import { baseURL } from "../config/constants";

export type ApiResponse = {
    data: {
        c: number;
        message: string;
        v?: any;
    };
}

const instance = axios.create({
    baseURL: baseURL,
    headers: {
        "Content-Type": "application/json",
    },
});

// validate response
instance.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (Token.getUser() !== undefined && error.response.status >= 400) {
            window.location.href = `/error?code=${error.response.status}`;
        }
        return Promise.reject(error);
    }
);

// set config for requests
instance.interceptors.request.use(
    (config) => {
        const token = Token.getLocalAccessToken() ?? "";
        const id = Token.getUser()?.id ?? "";
        config.headers["u-token"] = token ? token : "";
        config.headers["u-id"] = id ? id : 0;
        config.headers["app-t"] = Math.round((new Date()).getTime() / 1000);
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default instance;
